export interface AuthenticatedUser {
  id: string;
  email: string;
  name: string;
  picture?: string;
  provider: string;
}

import { apiFetch, googleLoginUrl } from './http';

export { googleLoginUrl };

/** Returns the current user, or `null` when there is no active session (HTTP 401). */
export async function getCurrentUser(): Promise<AuthenticatedUser | null> {
  try {
    return await apiFetch<AuthenticatedUser>('/auth/me');
  } catch (error) {
    if (error instanceof Error && 'status' in error && (error as { status: number }).status === 401) {
      return null;
    }
    throw error;
  }
}

export async function logout(): Promise<void> {
  await apiFetch<{ status: string }>('/auth/logout', { method: 'POST' });
}
